import { cn } from "@/lib/utils";

export function InfoIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-3.5 text-ice", className)}
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M7 0C3.136 0 0 3.136 0 7s3.136 7 7 7 7-3.136 7-7-3.136-7-7-7zm0 11.5c-.44 0-.8-.45-.8-1v-4c0-.55.36-1 .8-1 .44 0 .8.45.8 1v4c0 .55-.36 1-.8 1zm-.654-7.143c.328.328.992.32 1.311 0 .32-.32.328-.983 0-1.311-.328-.328-.983-.328-1.311 0-.328.328-.328.983 0 1.311z"
        fill="currentColor"
        fillOpacity="0.64"
        fillRule="evenodd"
      />
    </svg>
  );
}
